import { render, staticRenderFns } from "./exam_detail.vue?vue&type=template&id=296181ca&"
import script from "./exam_detail.vue?vue&type=script&lang=js&"
export * from "./exam_detail.vue?vue&type=script&lang=js&"
import style0 from "./exam_detail.vue?vue&type=style&index=0&id=296181ca&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports